<template>
  <div class="l-row">
    <form-group label="" :columns="12">
      <select class="form-select" v-model="announcementVariation.sku" :disabled="migration.done">
        <option :value=null>{{ $t('no.migration.label') }}</option>
        <option v-for="productVariation in productVariations" :key="productVariation" :value="productVariation.sku">
          {{ productVariationName(productVariation) }}
        </option>
      </select>
    </form-group>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      migration: {
        type: Object,
        required: true
      },
      announcementVariation: {
        type: Object,
        required: true
      },
      productVariations: {
        type: Array,
        required: true
      }
    },
    mounted () {
      let skuExists = this.productVariations.find(variation => variation.sku === this.announcementVariation.sku)

      if (!skuExists) {
        this.announcementVariation.sku = null
      }
    },
    methods: {
      productVariationName (variation) {
        let name = []

        if (variation.sku) {
          name.push(`SKU: ${variation.sku}`)
        }

        if (variation.ean) {
          name.push(`EAN: ${variation.ean}`)
        }

        if (variation.gender) {
          name.push(`Gênero: ${this.$t(`gender.${variation.gender}.label`)}`)
        }

        if (variation.attributes.color) {
          name.push(`Cor: ${variation.attributes.color}`)
        }

        if (variation.attributes.size) {
          name.push(`Tamanho: ${variation.attributes.size}`)
        }

        return name.join(' - ')
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// WithoutVariation.vue?34a57fc7